import { render, staticRenderFns } from "./TrainingStatusTag.vue?vue&type=template&id=306f093b&"
import script from "./TrainingStatusTag.vue?vue&type=script&lang=js&"
export * from "./TrainingStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports